var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.isMobile && _vm.showSideBar)?_c('side-bar',{attrs:{"mini":_vm.mini}}):_vm._e(),(!_vm.isMobile && !_vm.isIFrame)?_c('LayoutBar'):_vm._e(),_c('v-main',{staticStyle:{"height":"100%"}},[_c('v-alert',{attrs:{"type":"success","value":_vm.alert}},[_vm._v(_vm._s(_vm.alertText))]),_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }